@if (!showAlmostDone) {
  <div>
    <app-quote-summary
      (showAlmostDone)="showAlmostDone=$event">
    </app-quote-summary>
  </div>
} @else {
  <app-almost-done
    [showAlmostDone]="showAlmostDone"
    (showQuoteSummary)="showAlmostDone=$event">
  </app-almost-done>
}
